import React, { useEffect } from 'react';
import { Map } from 'immutable';
import { useSelector, useDispatch } from 'react-redux';
import {
  Node,
  Taxonomy as TaxonomyTerm,
  entityGetByPath,
  ContextualActionsWrapper,
  Profile,
  Webform,
  referenceLoadingReset,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import Page from '../Page';
import Forbidden from '../Forbidden';
import NotFound from '../NotFound';
import ServerError from '../ServerError';
import { usePrevious } from '../../helpers/usePrevious';

const Entity = () => {
  const dispatch = useDispatch();
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const entityStatus = useSelector((state) => state.getIn(['entity', 'status']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));

  const prevPath = usePrevious(path);
  const entityNotLoaded = !entityType || !entityId;
  const pathIsDifferentAndHasEntity = (path !== prevPath && typeof prevPath !== 'undefined') && (typeof entityStatus !== 'undefined' && entityStatus !== null);

  useEffect(() => {
    if (entityNotLoaded || (!entityNotLoaded && pathIsDifferentAndHasEntity)) {
      dispatch(referenceLoadingReset());
      dispatch(entityGetByPath(path));
    }
  }, [dispatch, entityNotLoaded, pathIsDifferentAndHasEntity, path]);

  if ((!entityType || !entityId) && entityExists) {
    return null;
  }

  if (entityStatus === 403) {
    return (
      <Container>
        <Forbidden />
      </Container>
    );
  } else if (entityStatus === 404) {
    return (
      <Container>
        <NotFound />
      </Container>
    );
  } else if (entityStatus === 500) {
    return (
      <Container>
        <ServerError />
      </Container>
    );
  }

  return (
    <ContextualActionsWrapper>
      <Page title={childEntity.getIn(['title', 0, 'value'], '')} path={path} prevPath={prevPath}>
        {entityType === 'node' && (
          <Node root id={entityId} />
        )}
        {entityType === 'taxonomy_term' && (
          <TaxonomyTerm root id={entityId} />
        )}
        {entityType === 'webform' && (
          <Container>
            <Webform root id={entityId} />
          </Container>
        )}
        {entityType === 'profile' && (
          <Profile root id={entityId} />
        )}
      </Page>
    </ContextualActionsWrapper>
  );
};

export default Entity;
